import {Component, Input, OnInit} from '@angular/core';
import {OonaPost} from '../../../../../../models/oona-post';
import {listOrderedPlatforms} from '../../../../../app.constants';
import {OonaReportComponent} from '../oona-report.component';
import {PdfExportService} from '../../../../../services/export-pdf/pdf-export.service';
import { UserService } from '../../../../../services/user.service';
@Component({
  selector: 'oona-report-item',
  templateUrl: './oona-report-item.component.html',
  styleUrls: ['./oona-report-item.component.scss']
})
export class OonaReportItemComponent implements OnInit {

  @Input() post: OonaPost;
  @Input() evenRow: boolean;
  // only use in pdf mode
  @Input() pageOrderNo: number;

  constructor(private pdfService: PdfExportService, private _userService: UserService) { }

  ngOnInit() {
  }

  onLoadedImage() {
    this.pdfService.updateNumberImageLoaded(`${OonaReportComponent.COMPONENT_NAME}${this.pageOrderNo}`);
  }

  platformName(platformId) {
    const platform = listOrderedPlatforms[platformId - 1];
    return platform ? platform.name.toLowerCase() : null;
  }

  get reachIndex() {
    return Math.abs(this.post.reachIndex);
  }

  getIndexStatus(value) {
    return value >= 100 ? 'asc' : 'desc';
  }

  get interactionIndex() {
    return Math.abs(this.post.interactionIndex);
  }

  get activeAccount() {
    return this._userService.getCompanyId();
  }
}



// WEBPACK FOOTER //
// ./src/app/main/measure/contents/oona-report/oona-report-item/oona-report-item.component.ts